export default function CTA() {
  return (
    <section className="section" id="contact">
      <div className="container">
        <div className="cta-card">
          <h2 className="cta-title">Let's see if we're a fit.</h2>
          <p className="cta-lede">
            Tell us what you're trying to build. A short call usually tells us
            whether we should partner, and if not, who you should talk to
            instead.
          </p>
          <div className="cta-actions">
            <a
              href="mailto:hello@viridiancloudpartners.com"
              className="btn btn-primary btn-large"
            >
              hello@viridiancloudpartners.com
            </a>
            <a href="#services" className="btn btn-large">
              What we do
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
